import React from 'react';

import './style.scss';

const Form = ({ children, action, method, onChange, onSubmit }) => {
  return (
    <form className="Form" action={action} method={method} onChange={onChange} onSubmit={onSubmit}>
      {children}
    </form>
  );
};

export default Form;
